import styled from 'styled-components';
import { Input, SubTitle, FormGrid } from '../../../style';

export const InternalOrExternalCard = styled.div`
  flex: 1;
  background: white;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
`;

export const CardTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
  margin: 0 0 4px 0;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const CheckboxContainer = styled.div<{ checked: boolean }>`
  width: 18px;
  height: 18px;
  border: 1px solid ${props => props.checked ? '#0090D3' : '#ebebeb'};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${props => props.checked ? '#0090D3' : 'white'};
`;

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  border: 2px solid ${props => props.checked ? '#0090D3' : '#cbd5e0'};
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: ${props => props.checked ? 'block' : 'none'};
    left: 4px;
    width: 4px;
    top: 1px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const InputContainer = styled.div`
  flex: 1;
  background: #ebebeb;
  border-radius: 20px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
`;

export const DeadlineLabel = styled.label`
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
  cursor: pointer;
  user-select: none;
`;

export const CustomCheckbox = styled.div<{ checked: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? '#0090D3' : '#EBEBEB')};
  border-radius: 4px;
  background-color: ${({ checked }) => (checked ? '#0090D3' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &::after {
    content: ${({ checked }) => (checked ? '"✓"' : '""')};
    color: white;
    font-weight: bold;
    font-size: 14px;
  }
`;

export const DateInput = styled(Input)`
  width: 150px;
`;

export const HeatTreatmentGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 25%;
`;

export const SwitchLabel = styled.label`
  font-weight: 700;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  margin-left: 1vw;
`;

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  width: 60px;
  height: 34px;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  border: #696969 2px solid;

  &:before {
    display: block;
    position: relative;
    content: "✕";
    height: 24px;
    width: 24px;
    left: 4px;
    top: 3px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    color: white;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  ${SwitchInput}:checked + & {
    background-color: #2196F3;
    border: 0;
  }

  ${SwitchInput}:checked + &:before {
    content: "✓";
    background-color: #fff;
    color: #2196F3;
    transform: translateX(26px);
  }
`;

export const DeadlineInput = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
  outline: none;
`;

export const HeatTreatmentContainer = styled.div`
  display: flex;
  margin-top: 3vh;
  align-items: center;
  margin-left: 1.5vw;
  margin-right: 4vw;
  flex-wrap: wrap;
  align-content: space-between;
  height: 120px;
`;

export const HeatTreatmentSubTitle = styled.h3`
  font-weight: 700;
  font-size: 10px;
  color: #696969;
  margin-top: 0;
  margin-bottom: 0;
`;

export const FileInputContainer = styled.div`
  border: 1px solid var(--border-color);
  border-radius: 20px;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
  background-color: rgb(235, 235, 235);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 25px;
  position: relative;
`;

export const FileInputSpan = styled.span`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileRemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--danger-color);
  padding: 0 0 0 8px;
`;

export const FileListContainer = styled.div`
  margin-top: 8px;
  font-size: 12px;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.8rem;
  margin-top: 8px;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const RequestedItemTitle = styled(SubTitle)`
  margin-top: 1rem;
`;

export const OfferedItemTitle = styled(SubTitle)`
  margin-top: 3rem;
`;

export const DeadlineSeparator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 10px 0;
`;

export const FormGridSingleColumn = styled.div`
  margin-top: 16px;
  grid-template-columns: 1fr;
`;

export const MaterialSearchInput = styled(Input)`
  padding-right: 40px;
`;

export const FormGridWithMargin = styled(FormGrid)<{ columns?: number }>`
  margin-top: 16px;
`;

export const ObservationsFormGrid = styled(FormGrid)`
  margin-top: 16px;
  grid-template-columns: 1fr;
`;

export const DeadlinesFormGrid = styled(FormGrid)`
  margin-top: 16px;
`;

export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5vh;
`;
